import React from "react";
import Utility from "../../utility/Utility";
import i18next from "i18next";
import { Pill } from "@els/els-react--pill";
interface ActiveInactiveType {
  statusValue: any;
  from?: string;
}

function ActiveInactive({ statusValue, from }: ActiveInactiveType) {
  let statusVal = statusValue.toLowerCase();
  if (statusVal === "active") {
    if (from === "profilePictureDetails") {
      //adding extra condition to check whether the component is being called from ProfilePictureDetails Component or not
      return (
        <Pill
          label={i18next.t(statusVal)}
          className="u-els-background-color-extended-green-0 u-els-color-extended-green-9"
        />
      );
    } else {
      return (
        <div className="activeInactiveText activeTextColor">
          {i18next.t(statusVal)}
        </div>
      );
    }
  } else if (statusVal === "not activated") {
    if (from === "profilePictureDetails") {
      //adding extra condition to check whether the component is being called from ProfilePictureDetails Component or not
      return (
        <Pill
          label={i18next.t(statusVal)}
          className="u-els-background-color-n1 u-els-color-n9"
        />
      );
    } else {
      return (
        <div className="activeInactiveText notActivatedTextColor">
          {i18next.t(statusVal)}
        </div>
      );
    }
  } else if (statusVal === "Inactive") {
    return (
      <Pill
        label={i18next.t(statusVal)}
        className="u-els-background-color-n5"
      />
    );
  } else {
    if (from === "profilePictureDetails") {
      //adding extra condition to check whether the component is being called from ProfilePictureDetails Component or not
      return (
        <Pill
          label={i18next.t(statusVal)}
          className="u-els-background-color-extended-pink-0 u-els-color-extended-pink-9"
        />
      );
    } else {
      return (
        <div className="activeInactiveText inactiveTextColor">
          {i18next.t(statusVal)}
        </div>
      );
    }
  }
}

export default ActiveInactive;
